export default __webpack_public_path__ + "bcfa974c23fc3c5ade538dd84404806e.png";